// extracted by css-extract-rspack-plugin
export default {"TokenList":"multi-select-renderer-module__TokenList__a6XWA","wrapping":"multi-select-renderer-module__wrapping__L_iFO"};